import React from "react";
import AllCourses from "../sections/course/AllCourses";

const AllCoursesPage = () => {
  return (
    <div>
      <AllCourses />
    </div>
  );
};

export default AllCoursesPage;
